import { render, staticRenderFns } from "./RingSound.vue?vue&type=template&id=64d09f10&scoped=true"
import script from "./RingSound.vue?vue&type=script&lang=js"
export * from "./RingSound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d09f10",
  null
  
)

export default component.exports